"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownFooter = void 0;
var _react = _interopRequireDefault(require("react"));
var _alloyReactFooter = _interopRequireWildcard(require("@adsk/alloy-react-footer"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const DropdownFooter = _ref => {
  let {
    isClearable = true,
    handleChange,
    // don't display clear button if there are no items
    shouldDisplay
  } = _ref;
  return isClearable && shouldDisplay ? /*#__PURE__*/_react.default.createElement(_alloyReactFooter.default, null, /*#__PURE__*/_react.default.createElement(_alloyReactFooter.ClearButton, {
    onClick: () => handleChange(null)
  })) : null;
};
exports.DropdownFooter = DropdownFooter;
//# sourceMappingURL=DropdownUtils.js.map